var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component component__spacing",style:([_vm.marginTop ? { marginTop: _vm.marginTop } : '', _vm.marginBottom ? { marginBottom: _vm.marginBottom } : ''])})}
var staticRenderFns = []

export { render, staticRenderFns }